<script setup>
import { ref, computed, onMounted, defineProps } from "vue";
import { useStore } from "vuex";

const store = useStore();
const props = defineProps({
  title: String
})
//touch

</script>

<template>
  <div class = "absolute-fill flex-center background">
    <slot style = "position: relative">

    </slot>
    <div class = "module-title">
      {{ props.title }}
    </div>
  </div>
</template>

<style lang="scss" scoped>

@import '../sass/GlobalClasses';
@import '../sass/Settings';

.background{
    @extend %absolute-fill;
    border-color: transparent;
    border-radius: vw(15);

    color: white;
    font-size: vw(44);
}

.back-button{
    position: absolute;
    left: vw(10);
    top: vw(10);
    background-color: (1, 1, 1, 0.1);
    pointer-events: auto;
}

.module-title{
  position: absolute;
  left: 0;
  bottom: vw(10);
  right: 0;
  height: vw(30);
  color: white;
  font-size: vw(18);
  text-align: center;
}

</style>
